import { Order }   from "../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
import { DeadlinePosition } from './model';
class Deadline extends Order {
  init(){
    super.init();
    this.watch();
    this.listenMount([this.onMountDeadline]);
  }
  onMountDeadline(){
    this.setPosition();
  }
  onChangeStore(a,b,c){
    super.onChangeStore(a, b, c);
    this.setPosition();
  }
  setPosition(){
    let pos = new DeadlinePosition(this.opts.deadline_raw);
    if(!pos.isStartOverLeft && !pos.isStartOverRight){
      let elem = this.querySelector('.border');
      if(elem == null){ return; }
      pos.setStyleFor(elem);
    }
  }
}
riot.mixin('orders.planner.deadline', Deadline as riot.TagMixin)
